import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_DOCUMENTUPLOAD: MijnRoute = {
    path: 'hypotheken-documentupload/:proces',
    navigationEvent: 'toHypothekenDocumentupload',
    regex: /^\/hypotheek\/hypotheken-documentupload\/[^/]+$/,
    webcomponent: 'mijn-hypotheken-documentupload-webcomponent'
};
